import React from "react"
import Rotas from "./Services/routes"
import { GlobalStyle } from "./Global/global"

export default function App() {
  return (
    <>
      <GlobalStyle />
      <Rotas />
    </>
  )
}
